import { GuardedComponent } from '../components/guarded-component';
import CocBillingReportPage from '../features/coc-billing-report/coc-billing-report.page';
import CocPage from '../features/coc/coc.page';
import { UserPermissionName } from '../models/user-permission-name';

export const CocBillingReportRoute = {
  path: '/coc-billing-reports',
  name: 'COC BILLING REPORT',
  children: [
    {
      index: true,
      element: (
        // <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_COC_REPORT]} showPermissionError>
        <CocBillingReportPage />
        // </GuardedComponent>
      ),
    },
  ],
};
